import React from "preact/compat";
import { h, Component } from 'preact';
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import constants from "../constants";
import { FileAddOutlined } from "@ant-design/icons";
import store from "../store";
import util from "../util";

export default function AsidePagesOptions() {

  function hideAside() {
    store.dispatch(actions.setIsMobileAside(false));
  }

  function viewAllPages() {
    store.dispatch(actions.setIsMobileAside(false));
    store.dispatch(actions.setIsViewAllPages(true));
    store.dispatch(actions.setSelectionType('pages'));
  }

  return (<div id="app-aside-pages-options">
    <ul>
      <li onClick={hideAside} id="add-page">
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-add-page"} />
        </svg>
        Add Page
      </li>

      <li onClick={hideAside} className="copy-page">
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-copy"} />
        </svg>
        Duplicate Page
      </li>


      <li onClick={hideAside} className={`${util.getNumberOfPages() <= 1 ? 'disabled' : 'remove-page'}`}>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-trash"} />
        </svg>
        Delete Page
      </li>

      <li onClick={viewAllPages}>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-pages"} />
        </svg>
        View All Pages
      </li>
    </ul>
  </div>)
}
